import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import {
  selectVirtualCard,
  selectVirtualCardIdFromRoute,
} from 'src/app/UpdateVirtualCardForm/redux/updateVirtualCardForm.selectors'
import UpdateVirtualCardForm from 'src/app/UpdateVirtualCardForm/UpdateVirtualCardForm'
import RightFlyout, {
  RightFlyoutBodyWidths,
} from 'src/components/RightFlyout/RightFlyout'
import { useFlyoutDispatch } from 'src/hooks'
import { connectedReplace } from 'src/navigation/Lnk'
import { updateBillPayUrl } from 'src/navigation/urls'
import {
  AutomationRuleListSortField,
  useAutomationRuleList,
} from 'src/queries/organizations/automationRules.queries'
import {
  getVirtualCard,
  getVirtualCardPermissions,
} from 'src/redux/actions/data/virtualCards.actions'

const UpdateVirtualCard: React.FC = () => {
  const dispatch = useFlyoutDispatch()
  const virtualCardId = useSelector(selectVirtualCardIdFromRoute)
  const virtualCard = useSelector(selectVirtualCard)
  const [loadingVirtualCard, setLoadingVirtualCard] = useState(true)
  const { isPending: rulesPending } = useAutomationRuleList({
    filters: {
      sortField: AutomationRuleListSortField.CreatedAt,
      sortDirection: 'DESC',
      fundingSourceIds: [virtualCardId],
    },
    enabled: virtualCardId !== undefined,
  })

  useEffect((): void => {
    if (virtualCardId) {
      setLoadingVirtualCard(true)
      dispatch(getVirtualCard(virtualCardId))
      dispatch(getVirtualCardPermissions(virtualCardId))
    }
  }, [virtualCard?.status, virtualCardId])

  useEffect(() => {
    if (virtualCard === undefined) return

    if (!virtualCard.isBillPay) {
      setLoadingVirtualCard(false)
    } else {
      // user is trying to access a bill pay card, redirect to the bill pay url
      dispatch(connectedReplace(updateBillPayUrl(virtualCardId)))
    }
  }, [virtualCard])

  return (
    <RightFlyout width={RightFlyoutBodyWidths.Action}>
      <UpdateVirtualCardForm
        virtualCardId={virtualCardId}
        virtualCard={virtualCard}
        loadingFlyout={loadingVirtualCard || rulesPending}
      />
    </RightFlyout>
  )
}

export default UpdateVirtualCard
